"use strict";

function extractRegionIdFromMapCode(code) {
  if (code === null || code === undefined || code === '') return '';
  var match = String(code).match(/(\d{6})$/);
  if (!match) return '';
  var regionId = Number(match[1]);
  return Number.isNaN(regionId) ? '' : regionId;
}
function isSameRegionCode(left, right) {
  var leftId = extractRegionIdFromMapCode(left);
  var rightId = extractRegionIdFromMapCode(right);
  return leftId !== '' && rightId !== '' && leftId === rightId;
}
function deriveRegionIdsFromAdcode(adcode) {
  var districtId = extractRegionIdFromMapCode(adcode);
  if (!districtId) {
    return {
      provinceId: '',
      cityId: '',
      districtId: ''
    };
  }
  var districtCode = String(districtId).padStart(6, '0');
  return {
    provinceId: Number("".concat(districtCode.slice(0, 2), "0000")),
    cityId: Number("".concat(districtCode.slice(0, 4), "00")),
    districtId: districtId
  };
}
function resolveMapRegionIds() {
  var selectedAddressDetail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var addressComponent = selectedAddressDetail.addressComponent || {};
  var derivedRegionIds = deriveRegionIdsFromAdcode(addressComponent.district_code || addressComponent.county_code || selectedAddressDetail.adcode || addressComponent.adcode || '');
  return {
    provinceId: extractRegionIdFromMapCode(addressComponent.province_code) || derivedRegionIds.provinceId,
    cityId: extractRegionIdFromMapCode(addressComponent.city_code) || derivedRegionIds.cityId,
    districtId: extractRegionIdFromMapCode(addressComponent.district_code || addressComponent.county_code) || derivedRegionIds.districtId
  };
}
function buildRegionSelectionPath() {
  var regionOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var regionIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var provinceId = regionIds.provinceId,
    cityId = regionIds.cityId,
    districtId = regionIds.districtId;
  var provinceNode = (regionOptions || []).find(function (item) {
    return isSameRegionCode(item.code, provinceId);
  });
  if (!provinceNode) return [];
  var selectionPath = [provinceNode.code];
  var cityNode = (provinceNode.children || []).find(function (item) {
    return isSameRegionCode(item.code, cityId);
  });
  if (!cityNode) return selectionPath;
  selectionPath.push(cityNode.code);
  var districtNode = (cityNode.children || []).find(function (item) {
    return isSameRegionCode(item.code, districtId);
  });
  if (!districtNode) return selectionPath;
  selectionPath.push(districtNode.code);
  return selectionPath;
}
function resolveRegionSelection() {
  var regionOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var selectedNodes = [];
  var currentNodes = regionOptions || [];
  (values || []).forEach(function (value) {
    var matchedNode = (currentNodes || []).find(function (item) {
      return isSameRegionCode(item.code, value);
    });
    if (matchedNode) {
      selectedNodes.push(matchedNode);
      currentNodes = matchedNode.children || [];
    }
  });
  return {
    province: selectedNodes[0] ? selectedNodes[0].name || '' : '',
    city: selectedNodes[1] ? selectedNodes[1].name || '' : '',
    district: selectedNodes[2] ? selectedNodes[2].name || '' : '',
    provinceId: selectedNodes[0] ? extractRegionIdFromMapCode(selectedNodes[0].code) : '',
    cityId: selectedNodes[1] ? extractRegionIdFromMapCode(selectedNodes[1].code) : '',
    districtId: selectedNodes[2] ? extractRegionIdFromMapCode(selectedNodes[2].code) : ''
  };
}
module.exports = {
  extractRegionIdFromMapCode: extractRegionIdFromMapCode,
  resolveMapRegionIds: resolveMapRegionIds,
  buildRegionSelectionPath: buildRegionSelectionPath,
  resolveRegionSelection: resolveRegionSelection
};